export type AppContextEntityType = 'candidate' | 'job' | 'analytics_dashboard';

export interface AppContextEntity {
  type: AppContextEntityType;
  id: number;
  /** Label the user knows the entity by — e.g. a job's title or a candidate's name. */
  displayName: string;
}

export interface TellentAssistantAppContext {
  entities: readonly AppContextEntity[];
}

export const EMPTY_APP_CONTEXT: TellentAssistantAppContext = { entities: [] };
